import { createFileRoute } from '@tanstack/react-router';
import { UserProfileContent } from './p.$id';

export const Route = createFileRoute('/p/$id/')({
  component: UserProfileIndexRoute,
});

function UserProfileIndexRoute() {
  const { id: userId } = Route.useParams();
  return <UserProfileContent userId={userId} page={1} />;
}
